// extracted by mini-css-extract-plugin
module.exports = {"new-link__button":"style_new-link__button__2I1kF","extra-m-t-20":"style_extra-m-t-20__3n2Hc","search-input":"style_search-input__1CFvp"};